import React from 'react';
import { loaderPageStyle } from './loader-page.style';

export function LoaderPage(): JSX.Element {
  return (
    <div className={loaderPageStyle}>
    </div>
  );
}
